import { render, staticRenderFns } from "./detail5.vue?vue&type=template&id=979fe962&scoped=true"
import script from "./detail5.vue?vue&type=script&lang=js"
export * from "./detail5.vue?vue&type=script&lang=js"
import style0 from "./detail5.vue?vue&type=style&index=0&id=979fe962&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "979fe962",
  null
  
)

export default component.exports